import React from 'react'

import '../../styles/pagina-macrolote.css'

const MacroloteInfo = ({info, english}) => {

    return (
        <div id="informacion" >
            <h1 className="titulo">{english ? 'TECHNICAL SHEET' : 'Ficha Técnica'}</h1>
            <div className="informacion-macrolote">
                {
                    info.map((bloque, index) => (
                        <div key={index} className="bloque-info">
                            <p className="enfasis">
                                {bloque.name}:
                            </p>
                            <p className="dato">
                                {bloque.dato}
                            </p>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default MacroloteInfo